import { UserModuleType } from "@tm/models"
import { useUser } from "../user/consumer/useUser"
import { getModuleFromUserContext } from "../helper"

// TODO: this hook should be removed when the article lsit v1 is no longer used. Probably by the end of 2025
export function useShowNewArticleList() {
    const { userContext } = useUser() || {}
    return getModuleFromUserContext(userContext, UserModuleType.Catalog)?.version == 2
}
